import type { ApolloError } from '@apollo/client';

/**
 * apollo-client 側で isApolloError が提供されているが、
 * 引数が undefined だった場合にエラーとなるため、独自で isApolloError を定義する。
 */

export const isApolloError = (error: any): error is ApolloError =>
  error !== undefined && error.hasOwnProperty('graphQLErrors');
